export const CARD_ORDER_DEEPLINK_QUERY_PARAMS = {
  APP_ID: 'app_id',
};

export const CARD_ORDER_DEEPLINK_LEGACY_PATH = '/order-physical-card';

export const CARD_ORDER_DEEPLINK_SESSION_KEYS = {
  RETURN_URL: 'card_order_deeplink.returnUrl',
};
